import {
  Api,
  getEmployees,
  getEmployeeById,
  getPaginatedEmployees,
  Employee,
  getEmployeeByEmail,
} from "@api";
import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import * as React from "react";
import { useState, useCallback } from "react";
import { M_TABLE_HEADERS_EMPLOYEES } from "../constants";
import CloseIcon from "@material-ui/icons/Close";
import { Form, Modal } from "@components";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { EmployeeDetails } from "./detail";
import { useEffect } from "react";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { useEmployeeStore } from "../../../../../store/hooksy";
import DataTable from "react-data-table-component";
import { Search } from "@components/table/toolbar/search-filters";
import { Actions } from "../../../../../screens/request/components/actions";
import { FormData } from "../../../../../screens/dashboard/admin/maintenance/employee/detail/form";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

const columns = [
  {
    name: M_TABLE_HEADERS_EMPLOYEES.EMAIL,
    selector: "email",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.LOCATION,
    selector: "location",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.USERID,
    selector: "userNtLogin",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.MANAGER_EMAIL,
    selector: "managerEmail",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.SECOND_MANAGER_EMAIL,
    selector: "secondManagerEmail",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.VP_EMAIL,
    selector: "vpemail",
  },
  {
    name: M_TABLE_HEADERS_EMPLOYEES.SVP_EMAIL,
    selector: "svpemail",
  },
];

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

type DataPaginated = {
  employees: Employee[];
  totalCount: number;
};

export interface DialogTitleProps extends WithStyles<typeof styles> {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

export type SelectedItem = {
  selectedEnv: Employee;
};

type FormValues = {
  email: string;
  location: string;
  userNtLogin: string;
  managerEmail: string;
  vpemail: string;
  svpemail: string;
  secondManagerEmail: string;
  divestitureCode: string;
  networkId: string;
};

type Key = keyof FormValues;

export const Employees: React.FC = () => {
  const [employeeStore, setEmployeeStore] = useEmployeeStore();

  const [employees, setEmployees] = useState<Employee[]>([]);
  const [dataList, setTableData] = useState<Row<Employee>[]>([]);
  const [isLoading, setIsloading] = useState<boolean>(true);
  const [open, setOpen] = React.useState<boolean>(false);
  const [openUpdate, setOpenUpdate] = React.useState<boolean>(false);
  const [action, setAction] = React.useState<string>("Add");
  const [where, setWhere] = React.useState<string>("");
  const [pending, setPending] = React.useState(false);
  const [selectedItem, setSelectedItem] = React.useState<Employee | undefined>(
    undefined
  );
  const [page, setPage] = React.useState<number>(1);
  const [perPage, setPerPage] = React.useState<number>(10);
  const [total, setTotal] = React.useState<number>(0);

  const updateData = () => {
    incrementCounter();
  };

  const onSearchUpdate = useCallback((term: string) => {
    setWhere(term);
  }, []);

  const handleClose = () => {
    setSelectedItem(undefined);
    setOpen(false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const form = Form.useManager<FormValues>({
    email: "",
    location: "",
    userNtLogin: "",
    managerEmail: "",
    vpemail: "",
    svpemail: "",
    secondManagerEmail: "",
    divestitureCode: "",
    networkId: "",
  });

  function onChange(name: Key, value: any): void {
    form.set(Form.target.VALUE, [name, value]);
    validate([name, value]).then(([name, error]) => {
      form.set(Form.target.ERROR, [name, error]);
    });
  }

  function validate([name, value]: [string, any]): Promise<[Key, Error?]> {
    switch (name) {
      case "email":
      case "managerEmail":
        return Promise.resolve([
          name as Key,
          Form.Validators.hasValue(value) || Form.Validators.isEmail(value),
        ]);

      // case "userNtLogin":
      //   return Promise.resolve([name as Key, Form.Validators.hasValue(value)]);
      case "vpemail":
      case "svpemail":
      case "secondManagerEmail":
        if (value != null && value != "") {
          return Promise.resolve([name as Key, Form.Validators.isEmail(value)]);
        }
      default:
        return Promise.resolve([name as Key]);
    }
  }

  function handleAddButtonClick(): void {
    setPending(true);
    Api.employee
      .postEmployee({
        ...form.values,
      })
      .then(() => {
        setPending(false);
        setIsOpenConfirmationModal(false);
        form.reset();
        handleClose();
        updateData();
      })
      .catch((error) => {
        setPending(false);
        // [TODO] Handle error
      });
  }

  function handleSubmitButtonClick(): void {
    Promise.all(Object.entries(form.values).map(validate)).then(
      (validations) => {
        const valid = validations.reduce((valid, [name, error]) => {
          return valid && !error;
        }, true);
        if (valid) {
          setIsOpenConfirmationModal(true);
        } else {
          validations.forEach(([name, error]) => {
            form.set(Form.target.ERROR, [name, error]);
          });
        }
      }
    );
  }

  const showModal = () => {
    setOpen(true);
  };

  // get the updated employee by id
  useEffect(() => {
    // console.log(employeeStore);
    const employeeId = employeeStore.employeeId;
    if (employeeId) {
      getEmployeeById(employeeId)
        .then((response: any) => {
          let employeesCopy: any = dataList;
          let updatedEmployee = response;
          let employeesNewCopy: any = [];
          employeesCopy.forEach((d: any) => {
            if (updatedEmployee.id === d.id) {
              employeesNewCopy = [
                ...employeesNewCopy,
                {
                  id: updatedEmployee.id,
                  chatId: updatedEmployee.id,
                  email: updatedEmployee.email,
                  location: updatedEmployee.location,
                  managerEmail: updatedEmployee.managerEmail,
                  managerName: updatedEmployee.managerName,
                  name: updatedEmployee.name,
                  secondManagerEmail: updatedEmployee.secondManagerEmail,
                  sendChatAlert: updatedEmployee.sendChatAlert,
                  showChatNotification: updatedEmployee.showChatNotification,
                  showRobot: updatedEmployee.showRobot,
                  svpemail: updatedEmployee.svpemail,
                  svpname: updatedEmployee.svpname,
                  userNtLogin: updatedEmployee.userNtLogin,
                  vpemail: updatedEmployee.vpemail,
                  vpname: updatedEmployee.vpname,
                  workDayId: updatedEmployee.vpname,
                  divestitureCode: updatedEmployee.divestitureCode,
                  networkId: updatedEmployee.networkId,
                },
              ];
            } else {
              employeesNewCopy = [
                ...employeesNewCopy,
                {
                  id: d.id,
                  chatId: d.id,
                  email: d.email,
                  location: d.location,
                  managerEmail: d.managerEmail,
                  managerName: d.managerName,
                  name: d.name,
                  secondManagerEmail: d.secondManagerEmail,
                  sendChatAlert: d.sendChatAlert,
                  showChatNotification: d.showChatNotification,
                  showRobot: d.showRobot,
                  svpemail: d.svpemail,
                  svpname: d.svpname,
                  userNtLogin: d.userNtLogin,
                  vpemail: d.vpemail,
                  vpname: d.vpname,
                  workDayId: d.vpname,
                  divestitureCode: d.divestitureCode,
                  networkId: d.networkId,
                },
              ];
            }
          });
          // console.log(employeesNewCopy.find((x: any) => x.id === 44));
          setTableData(employeesNewCopy);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [employeeStore]);

  const [counter, updateCounter] = React.useState(0);
  const [isOpenConfirmationModal, setIsOpenConfirmationModal] = React.useState<
    boolean
  >(false);

  useEffect(() => {
    getPaginatedEmployees(page, perPage, where).then(
      (response: DataPaginated) => {
        setEmployees(response.employees);
        setTotal(response.totalCount);
        setIsloading(false);
      }
    );
  }, [counter, page, where]);

  const incrementCounter = () => {
    updateCounter(counter + 1);
  };

  const DialogTitle = withStyles(styles)((props: DialogTitleProps) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

  let editModal = null;
  if (!!selectedItem) {
    editModal = (
      <EmployeeDetails
        id={0}
        data={selectedItem}
        isOpen={openUpdate}
        onClickAdd={updateData}
        onClickClose={handleClose}
        action={action}
      />
    );
  }
  //else {
  //    editModal = (<EmployeeDetails id={0} data={undefined} isOpen={open} onClickAdd={updateData} onClickClose={handleClose} action={action} />);
  //}

  const pageName = "Employees";
  return (
    <Box mt={2}>
      {editModal}
      <Modal
        isOpen={isOpenConfirmationModal}
        positionButton="center"
        actions={[
          {
            label: "Cancel",
            variant: "outlined",
            handler: () => {
              setIsOpenConfirmationModal(false);
            },
          },
          {
            label: pending ? "Submitting..." : "Submit",
            handler: () => {
              handleAddButtonClick();
            },
            disabled: pending,
          },
        ]}
      >
        <Typography align="center" paragraph>
          Are you sure you want to add this Employee?
        </Typography>
      </Modal>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth={"sm"}
      >
        <DialogTitle id="form-dialog-title" onClose={handleClose}>
          Add New Employee
        </DialogTitle>
        <DialogContent>
          <FormData data={undefined} onHandleChange={onChange} form={form} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSubmitButtonClick} color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>

      <MaintenanceBreadcrumbs title={pageName} />
      <Grid container direction="row" spacing={1} justify="space-between">
        <Grid item xs={"auto"}>
          <Actions>
            <Actions.Action onClick={handleClickOpen}>
              + Add New Employee
            </Actions.Action>
          </Actions>
        </Grid>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Email"}
          ></Search>
        </Grid>
      </Grid>
      <DataTable
        columns={columns}
        data={employees}
        highlightOnHover
        pagination
        paginationServer
        paginationTotalRows={total}
        paginationPerPage={perPage}
        paginationComponentOptions={{
          noRowsPerPage: true,
        }}
        pointerOnHover
        onChangePage={(page) => setPage(page)}
        paginationRowsPerPageOptions={[10, 30, 50]}
        onChangeRowsPerPage={(page) => setPage(page)}
        data-tag="allowRowEvents"
        onRowClicked={(data) => {
          setSelectedItem(data);
          setAction("Edit");
          setOpenUpdate(true);
        }}
      />
    </Box>
  );
};
